import { useAppSelector } from 'store/store';
import { BottomFromTechnicianRoles } from 'shared/permissions/roles';

export function IsBottomFromTechnician({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups?.some((role) => BottomFromTechnicianRoles.includes(role))) return children;
}
